import Presets, { type PresetsType } from '@assets/hdri';
import { useLocalization } from '@lib/localization';
import { CardContent, FormControl, InputLabel, MenuItem, Paper, Select } from '@mui/material';
import { useUpdatePreferencesMutation } from '@store/api/authEndpoints';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { chooseRoomEnvironment, defaultRoomEnv } from '@store/reducers/viewerSlice';
import { CardDescription, CardHeader, CardTitle } from './Settings.styled';

const ViewerEnvironmentCard = () => {
  const dispatch = useAppDispatch();
  const { roomEnvironment } = useAppSelector(state => state.viewer);
  const { t } = useLocalization();
  const [updatePreferences] = useUpdatePreferencesMutation();

  // On screen at once and onto the account behind it, as the language card does.
  const handleChangeEnvironment = (val: string) => {
    dispatch(chooseRoomEnvironment(val));
    updatePreferences({ roomEnvironment: val as PresetsType });
  };

  return (
    <Paper sx={{ mb: 2 }}>
      <CardHeader>
        <CardTitle variant="h6">{t('Settings_ViewerRoomEnv')}</CardTitle>
        <CardDescription variant="body2">{t('Settings_ViewerRoomEnv_Subtitle')}</CardDescription>
      </CardHeader>
      <CardContent style={{ padding: '24px' }}>
        <FormControl fullWidth size="small">
          <InputLabel id="environment-select-label">{t('Settings_ViewerRoomEnv_Select')}</InputLabel>
          <Select
            labelId="environment-select-label"
            value={roomEnvironment}
            onChange={(val) => { handleChangeEnvironment(val.target.value); }}
            label={t('Settings_ViewerRoomEnv_Select')}
          >
            {Object.entries(Presets)
              .map(([key, _v]) => (
                <MenuItem key={key} value={key}>
                  {`${t(`Settings_ViewerRoomEnv_${key.capitalize()}`)}${key === defaultRoomEnv
                    ? ` (${t('Common_Default')})`
                    : ''}`
                  }
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </CardContent>
    </Paper>
  );
};

export default ViewerEnvironmentCard;
